import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextAndImageComponent } from './text-and-image.component';
import { ScreenViewModule } from '../../../../../../core/directives/screen-view/_screen-view.module';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { ColorPipe } from '../../theme/core/assets/color.pipe';
import { GenericLinkModule } from '@spartacus/storefront';

@NgModule({
  declarations: [TextAndImageComponent],
  imports: [CommonModule, ScreenViewModule, GenericLinkModule],
  providers: [
    ColorPipe,
    provideConfig({
      cmsComponents: {
        TextAndImageComponent: {
          component: TextAndImageComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class TextAndImageModule {}
